import React, { useState } from "react";
import { Toaster } from "react-hot-toast";
import {
  Ellipsis,
  FolderCog,
  Globe2,
  Layers3,
  PlusCircle,
} from "lucide-react";

import DomainTab from "./Domains";
import CreateDomain from "./CreateDomain";
import Templates from "./Templates";
import Websites from "./Websites";
import useDomain from "../Services/DomainServices/useDomain";

const tabs = [
  {
    id: "domain",
    label: "Create Domain",
    icon: PlusCircle,
  },
  {
    id: "templates",
    label: "Templates",
    icon: Layers3,
  },
  {
    id: "websites",
    label: "Websites",
    icon: Globe2,
  },
  {
    id: "domains",
    label: "Domains",
    icon: Ellipsis,
  },
];

export default function AdminSubdomainTabs() {
  const [activeTab, setActiveTab] = useState("domain");

  const domainHook = useDomain();

  return (
    <div className="p-3 lg:p-5">
      <Toaster position="top-right" />

      {/* HEADER */}
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="grid h-10 w-10 place-items-center rounded-xl bg-[#01C37D]/10 text-[#01C37D]">
            <FolderCog size={18} />
          </div>

          <div>
            <h1 className="text-xl font-semibold">Domain Management</h1>

            <p className="text-sm text-gray-500">
              Create domains, deploy templates and manage active websites.
            </p>
          </div>
        </div>
      </div>

      {/* MAIN TABS */}
      <div className="rounded-2xl border bg-white p-2">
        <div className="flex gap-2 overflow-x-auto rounded-xl border bg-white p-2">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const active = activeTab === tab.id;

            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`inline-flex shrink-0 items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition ${
                  active
                    ? "bg-gray-100 text-gray-900"
                    : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                <Icon size={16} />

                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* CONTENT */}
      <div className="mt-3">
        {activeTab === "domain" && <CreateDomain {...domainHook} />}
        {activeTab === "templates" && <Templates {...domainHook} />}
        {activeTab === "websites" && <Websites {...domainHook} />}
        {activeTab === "domains" && <DomainTab {...domainHook} />}
      </div>
    </div>
  );
}
